/**
 * UC-30: HireEmployee
 * TOGAF Application ABB — HR dashboard hire action without UI deps.
 */
import type { Employee, EmployeeType } from '../../../types';
import type { IAppLogger } from '../../domain/ports/IAppLogger';
import type { IOrgManagement } from '../../domain/ports/IOrgManagement';

export interface HireEmployeeInput {
  type: EmployeeType;
  currentOrgSize: number;
}

export interface HireEmployeeOutput {
  ok: boolean;
  employee?: Employee;
  error?: string;
}

export interface HireEmployeeDependencies {
  orgManagement: IOrgManagement;
  logger?: IAppLogger;
}

export class HireEmployeeUseCase {
  constructor(private readonly deps: HireEmployeeDependencies) {}

  execute(input: HireEmployeeInput): HireEmployeeOutput {
    try {
      const employee = this.deps.orgManagement.hireEmployee(
        input.type,
        input.currentOrgSize,
      );

      this.deps.logger?.log('debug', 'org.employee_hired', {
        employeeId: employee.id,
        type: input.type,
      });

      return { ok: true, employee };
    } catch (error) {
      const message = error instanceof Error ? error.message : String(error);
      this.deps.logger?.log('warn', 'org.hire_failed', { type: input.type, error: message });
      return { ok: false, error: message };
    }
  }
}